import apiClient from "../_helpers/api-client";

export const manufacturersService = {
  getAllManufacturers,
  addManufacturer,
  editManufacturer,
  deleteManufacturer,
  addModel,
  editModel,
  deleteModel
};

async function getAllManufacturers() {
  return await apiClient.get("/api/v4/manufacturers");
}
async function addManufacturer(data) {
  return await apiClient.post("/api/v4/manufacturers", data);
}
async function editManufacturer({ id, name }) {
  return await apiClient.put(`/api/v4/manufacturers/${id}`, { id, name });
}
async function deleteManufacturer({ id }) {
  return await apiClient.delete(`/api/v4/manufacturers/${id}`);
}
async function addModel({ manufacturerId, id, isSelectable, name }) {
  return await apiClient.post(
    `/api/v4/manufacturers/${manufacturerId}/models`,
    {
      id,
      isSelectable,
      name,
      manufacturerId
    }
  );
}
async function editModel({ manufacturerId, id, isSelectable, name }) {
  return await apiClient.put(
    `/api/v4/manufacturers/${manufacturerId}/models/${id}`,
    {
      id,
      isSelectable,
      name,
      manufacturerId
    }
  );
}
async function deleteModel({ id, manufacturerId }) {
  return await apiClient.delete(
    `/api/v4/manufacturers/${manufacturerId}/models/${id}`
  );
}
